import React from 'react';
import { Button, Typography } from '@ghq-abi/design-system-v2';

import { cn } from '~/lib/utils';

export interface TabOption {
  id: string;
  label: string;
  value: string | number;
}

export interface TabsProps {
  options: TabOption[];
  selectedValue?: string | number | null;
  onSelect?: (option: TabOption) => void;
  className?: string;
}

const Tabs: React.FC<TabsProps> = ({
  options,
  selectedValue,
  onSelect,
  className
}) => {
  const handleTabClick = (option: TabOption) => {
    if (onSelect) {
      onSelect(option);
    }
  };

  return (
    <div className={cn('flex border-b border-gray-300', className)}>
      {options.map(option => {
        const isSelected = selectedValue === option.value;

        return (
          <Button
            key={option.id}
            variant="secondary"
            onClick={() => handleTabClick(option)}
            className={cn(
              'relative px-6 py-3 mr-0 rounded-none border-0 border-b-2 transition-all duration-200 justify-center',
              isSelected
                ? 'border-b-yellow-500 bg-transparent'
                : 'border-b-transparent bg-transparent hover:border-b-gray-200'
            )}>
            <Typography
              variant={isSelected ? 'body-sm-bold' : 'body-sm-regular'}
              color={isSelected ? 'default' : 'light'}>
              {option.label}
            </Typography>
          </Button>
        );
      })}
    </div>
  );
};

export default Tabs;
